import React,{useState,useRef,useEffect} from 'react'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import { Formik, Field, FieldArray, ErrorMessage, getIn } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL } from '../../services/redirect'
import { ValidateForm } from '../../validations/schemaCustomer'
import { DropdownComponent } from '../../components/options'
import AuthDenied from '../ErrorPage/denied'


export default function NewCustomerComponent(props){


  /*----------------------------------------
    GENERATE PASSWORD
  -----------------------------------------*/

  function MakePassword(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnpqrstuvwxyz123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
     }
     return result;
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }



  /*----------------------------------------
    Handle Form Submit
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [state, setState] = useState({
    account_number:'',
    account_name:'',
    short_name:'',
    email:'',
    password:'',
    send_password:'2',
    activities:'2',
    comments:'',
    status:'1',
    status_pricing:'2',
    account_type:'1',
    address:[{
      pharmacy:'12345',
      reference:'12345',
      phone:'',
      line_1:'',
      line_2:'',
      line_3:'',
      city:'',
      county:'',
      postcode:'',
      country:'United Kingdom',
    }],
  });

  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','add');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/customers/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {
            WindowLocation('/customers/list');
          },2000);
        }else{
          props.resetForm();
          setTimeout(function() {
            setnotify(false);
          },2000);
        }
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });


  }



  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [countryOptions, setCountryOptions] = useState([]);
  const [activityOptions, setActivityOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [yesnoOptions, setyesnoOptions] = useState([]);
  const [onoffOptions, setonoffOptions] = useState([]);
  const [accountTypeOptions, setaccountTypeOptions] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setCountryOptions(source.country);
    setActivityOptions(source.activities);
    setStatusOptions(source.status);
    setyesnoOptions(source.yesno);
    setonoffOptions(source.on_off_status);
    setaccountTypeOptions(source.account_type);
  }



  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('pe4wsybrqkz1ch2tg');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1){
        }
        setloader(false);
    })
    .catch(function (error){
      setloader(false);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
    HandleOptions();
  },[]);

  return (
    <React.Fragment>

      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

      {((authPages['view']==0||authPages['adding']==0)&&!loader)&&<AuthDenied/>}
      {(authPages['view']==1&&!loader)&&<React.Fragment>

      <div className="page-wrapper-one">
        <div className="app-page-title">
         <div className="page-title-wrapper">
            <div><h1>New Customer</h1></div>
            <div>
              <Button className='LigthGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
              <Button className='GreenButton strong' size='tiny' content='Back to list' icon='arrow left icon' as="a" href={WindowURL('/customers/list')}/>
            </div>
          </div>
       </div>
      <div className="app-body-wrapper">
      <Form>
        <Formik
            enableReinitialize
            initialValues={state}
            validationSchema={ValidateForm}
            onSubmit={handleSubmitForm}
            render={formProps => {
            const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

            return(
                    <div className="page-form-panel">
                        <div className="page-form-body">
                        <div class="alert-message left error">
                            <div><i class="info circle icon"></i></div>
                            <div><p>Fields with asterisk is required.</p></div>
                        </div>
                        <br/>

                         {/* Layout Form 2 Column*/}
                           <div className="layout-one-column">
                              <div>
                                    <Form.Group widths="equal">
                                        <Field name="account_number">
                                            {({ field, form }) => (
                                            <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Account Number</label>
                                              <Cleave {...field} onChange={handleChange} placeholder="Enter number only" options={{numericOnly: true}} maxLength="15"/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                            )}
                                      </Field>
                                     </Form.Group>
                                     <Form.Group widths="equal">
                                           <Field name="account_name">
                                               {({ field, form }) => (
                                               <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                 <label>Account Name</label>
                                                 <Input {...field} onChange={handleChange}/>
                                                 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                               </Form.Field>
                                               )}
                                         </Field>
                                      </Form.Group>
                                      <Form.Group widths="equal">
                                            <Field name="short_name">
                                                {({ field, form }) => (
                                                <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                  <label>Profile Name</label>
                                                  <Input {...field} onChange={handleChange} maxLength="150" placeholder="Max of 20 characters"/>
                                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                </Form.Field>
                                                )}
                                          </Field>
                                       </Form.Group>

                                       <div class="alert-message left info" style={{'margin-bottom':'15px'}}>
                                           <div><i class="info circle icon"></i></div>
                                           <div>
                                              <p>Profile name will be use in customer portal.</p>
                                              <p>Example: Instead of <span style={{'font-weight':'700'}}>John Pharmacy Ltd T/A Charles John Pharmacy</span>, make it short like <span style={{'font-weight':'700'}}>John Pharmacy</span>.</p>
                                           </div>
                                       </div>

                                      <Form.Group widths="equal">
                                          <Field name="email">
                                              {({ field, form }) => (
                                              <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                <label>Email</label>
                                                <Input {...field} onChange={handleChange}/>
                                                { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                              </Form.Field>
                                              )}
                                        </Field>
                                     </Form.Group>

                                    <Form.Group widths="equal">
                                        <Field name="password">
                                            {({ field, form }) => (
                                            <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Password</label>
                                              <Input {...field} onChange={handleChange} autoComplete="off"/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                            )}
                                      </Field>
                                      <Field name="send_password">
                                          {({ field, form }) => (
                                            <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Send password to email?</label>
                                              <Select selectOnBlur={false}
                                                  {...field}
                                                  options={yesnoOptions}
                                                  onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                          )}
                                      </Field>
                                   </Form.Group>


                                   <div class="alert-message left info" style={{'margin-bottom':'5px'}}>
                                       <div><i class="info circle icon"></i></div>
                                       <div><p>You can type the password manually or click the button to generate for you.</p></div>
                                   </div>
                                   <Form.Group inline>
                                     <Button className='BlueButton strong' size='tiny' content='Click to Generate Password'  icon='sync alternate' style={{'margin-right':'20px'}} onClick={()=>{
                                        var password = MakePassword(7);
                                        setFieldValue('password',password);
                                     }}/>
                                   </Form.Group>
                                   <br/>


                                   {/*--------------------------------------------------------------------------------
                                      Dynamic address for account type
                                   ---------------------------------------------------------------------------------*/}


                                   <Form.Group widths="equal">
                                      <Field name="account_type">
                                        {({ field, form }) => (
                                            <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Account Type</label>
                                              <Select
                                                  selectOnBlur={false}
                                                  search
                                                  {...field}
                                                  options={accountTypeOptions}
                                                  onChange={(e, { value }) => {
                                                    setFieldValue(field.name,value)
                                                    if(value==2){
                                                      setFieldValue('address',[{
                                                        pharmacy:'',
                                                        reference:'',
                                                        phone:'',
                                                        line_1:'',
                                                        line_2:'',
                                                        line_3:'',
                                                        city:'',
                                                        county:'',
                                                        postcode:'',
                                                        country:'United Kingdom'
                                                      }])
                                                    }else{
                                                      setFieldValue('address',[{
                                                        pharmacy:'12345',
                                                        reference:'12345',
                                                        phone:'',
                                                        line_1:'',
                                                        line_2:'',
                                                        line_3:'',
                                                        city:'',
                                                        county:'',
                                                        postcode:'',
                                                        country:'United Kingdom'
                                                      }])
                                                    }
                                                    
                                                  }}/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                        )}
                                      </Field>
                                  </Form.Group>

                                  
                                  <FieldArray
                                    name="address"
                                    render={arrayHelpers => (
                                      <div>
                                        {values.address.map((variation, index) => (
                                          <div key={index}>

                                            <div className="addressLinePanel">

                                            {values.account_type==2&&<Form.Group widths="equal">
                                                <Field name={`address[${index}].pharmacy`}>
                                                        {({ field, form }) => (
                                                        <Form.Field required crequired className={(() => {return getIn(form.errors, `address.${index}.pharmacy`) && getIn(form.touched, `address.${index}.reference`) ? 'error' : "";})()}>

                                                          <label>Pharmacy</label>
                                                          
                                                          <Input {...field} onChange={handleChange}  maxLength="50"/>

                                                          { getIn(form.touched, `address.${index}.pharmacy`) && getIn(form.errors, `address.${index}.pharmacy`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.reference`)}</Label> }

                                                        </Form.Field>
                                                        )}
                                                </Field>
                                            </Form.Group>}

                                            {values.account_type==2&&<Form.Group widths="equal">
                                                <Field name={`address[${index}].reference`}>
                                                        {({ field, form }) => (
                                                        <Form.Field required crequired className={(() => {return getIn(form.errors, `address.${index}.reference`) && getIn(form.touched, `address.${index}.reference`) ? 'error' : "";})()}>

                                                          <label>Reference</label>
                                                          
                                                          <Cleave {...field} onChange={handleChange} placeholder="Enter number only" options={{numericOnly: true}} maxLength="4"/>

                                                          { getIn(form.touched, `address.${index}.reference`) && getIn(form.errors, `address.${index}.reference`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.reference`)}</Label> }

                                                        </Form.Field>
                                                        )}
                                                </Field>
                                            </Form.Group>}

                                             <Form.Group widths="equal">
                                                <Field name={`address[${index}].line_1`}>
                                                    {({ field, form }) => (
 
                                                   <Form.Field required className={(() => {return getIn(form.errors, `address.${index}.line_1`) && getIn(form.touched, `address.${index}.line_1`) ? 'error' : "";})()}>

                                                      <label style={{'position':'relative'}}>Address Line 1

                                                      {(values.address.length>1&&index>0)&&<span style={{'position':'absolute','right':'0', 'cursor':'pointer'}} onClick={() => arrayHelpers.remove(index)}><i className="close icon" style={{'color':'#e41e2e'}}></i></span>}
                                                      
                                                      </label>
                                                      <TextArea rows='2' {...field} onChange={handleChange}/>

                                                      { getIn(form.touched, `address.${index}.line_1`) && getIn(form.errors, `address.${index}.line_1`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.line_1`)}</Label> }

                                                    </Form.Field>
                                                    )}
                                                </Field>
                                              </Form.Group>

                                              <Form.Group widths="equal">
                                                <Field name={`address[${index}].line_2`}>
                                                    {({ field, form }) => (
 
                                                   <Form.Field className={(() => {return getIn(form.errors, `address.${index}.line_2`) && getIn(form.touched, `address.${index}.line_2`) ? 'error' : "";})()}>

                                                      <label>Address Line 2</label>
                                                      <TextArea rows='2' {...field} onChange={handleChange}/>

                                                      { getIn(form.touched, `address.${index}.line_2`) && getIn(form.errors, `address.${index}.line_2`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.line_1`)}</Label> }

                                                    </Form.Field>
                                                    )}
                                                </Field>
                                              </Form.Group>

                                              <Form.Group widths="equal">
                                                <Field name={`address[${index}].line_3`}>
                                                    {({ field, form }) => (
 
                                                   <Form.Field className={(() => {return getIn(form.errors, `address.${index}.line_3`) && getIn(form.touched, `address.${index}.line_3`) ? 'error' : "";})()}>

                                                      <label>Address Line 3</label>
                                                      <TextArea rows='2' {...field} onChange={handleChange}/>

                                                      { getIn(form.touched, `address.${index}.line_3`) && getIn(form.errors, `address.${index}.line_3`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.line_1`)}</Label> }

                                                    </Form.Field>
                                                    )}
                                                </Field>
                                              </Form.Group>

                                              <Form.Group widths="equal">
                                                    <Field name={`address[${index}].phone`}>
                                                        {({ field, form }) => (
                                                        <Form.Field required crequired className={(() => {return getIn(form.errors, `address.${index}.phone`) && getIn(form.touched, `address.${index}.phone`) ? 'error' : "";})()}>

                                                          <label>Phone</label>
                                                          <Input {...field} onChange={handleChange}/>

                                                          { getIn(form.touched, `address.${index}.phone`) && getIn(form.errors, `address.${index}.phone`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.phone`)}</Label> }

                                                        </Form.Field>
                                                        )}
                                                  </Field>
                                                  </Form.Group>
                                                  <Form.Group widths="equal">
                                                      <Field name={`address[${index}].city`}>
                                                          {({ field, form }) => (
                                                          <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                            <label>City</label>
                                                            <Input {...field} onChange={handleChange}/>
                                                            { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                          </Form.Field>
                                                          )}
                                                    </Field>
                                                      <Field name={`address[${index}].county`}>
                                                          {({ field, form }) => (
                                                          <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                            <label>County</label>
                                                            <Input {...field} onChange={handleChange}/>
                                                            { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                          </Form.Field>
                                                          )}
                                                    </Field>
                                                </Form.Group>
                                                <Form.Group widths="equal">
                                                    <Field name={`address[${index}].postcode`}>
                                                        {({ field, form }) => (
                                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                          <label>Postcode</label>
                                                          <Input {...field} onChange={handleChange}/>
                                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                        </Form.Field>
                                                        )}
                                                  </Field>
                                                  <Field name={`address[${index}].country`}>
                                                    {({ field, form }) => (
                                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                          <label>Country</label>
                                                          <Select
                                                              selectOnBlur={false}
                                                              search
                                                              {...field}
                                                              options={countryOptions}
                                                              onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                        </Form.Field>
                                                    )}
                                                  </Field>
                                              </Form.Group>

                                            </div>

                                          </div>
                                          ))}

                                        {values.account_type==2&&<Button className='GreenButton strong' size='tiny' content='Add Address'  icon='uil-plus icon' onClick={() => arrayHelpers.push({
                                            reference:'',
                                            phone:'',
                                            line_1:'',
                                            line_2:'',
                                            line_3:'',
                                            city:'',
                                            county:'',
                                            postcode:'',
                                            country:'United Kingdom',
                                          }
                                        )}/>}

                                    </div>
                                   )}/>


                                  {/*--------------------------------------------------------------------------------
                                      Dynamic address for account type : End
                                   ---------------------------------------------------------------------------------*/}

                                  

                             </div>
                             <div>
                              <Form.Group widths="equal">
                                  <Field name="activities">
                                    {({ field, form }) => (
                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                          <label>Activities</label>
                                          <Select
                                              selectOnBlur={false}
                                              search
                                              {...field}
                                              options={activityOptions}
                                              onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                        </Form.Field>
                                    )}
                                  </Field>
                               </Form.Group>
                                <Form.Group widths="equal">
                                  <Field name="comments">
                                      {({ field, form }) => (
                                      <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                        <label>Comments</label>
                                        <TextArea {...field} onChange={handleChange}/>
                                        { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                      </Form.Field>
                                      )}
                                  </Field>
                                </Form.Group>

                                <Form.Group widths="equal">
                                  <Field name="status_pricing">
                                      {({ field, form }) => (
                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                          <label>Product pricing?</label>
                                          <Select selectOnBlur={false}
                                              {...field}
                                              options={onoffOptions}
                                              onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                                        </Form.Field>
                                      )}
                                  </Field>
                                  <Field name="status">
                                      {({ field, form }) => (
                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                          <label>Status</label>
                                          <Select selectOnBlur={false}
                                              {...field}
                                              options={statusOptions}
                                              onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                                        </Form.Field>
                                      )}
                                  </Field>
                                </Form.Group>
                              </div>


                          </div>
                            {/* Layout Form 2 Column End disabled={!(isValid&&dirty)}*/}


                        </div>{/*.page-form-body*/}

                        <div className="page-form-footer">
                            <Button disabled={spinner||authPages['adding']==0} className='LightGrayButton strong' size='small' content='Save and back to list' icon='save icon' onClick={() => buttonSubmit(1)}/>
                            <Button disabled={spinner||authPages['adding']==0} className='PrimaryButton strong' size='small' content='Save and stay on page' icon='save icon' onClick={() => buttonSubmit(2)}/>
                            <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                        </div>

                 </div>

            )}}/>
          </Form>
          </div>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}
